import React from "react";
import { TessaMessageRendererProps } from "@webV2/pages/Tessa/types";
import {
  AiChatToolBuildWorkplaceRequestOutput,
  AiChatToolBuildWorkplaceRequestPart
} from "@gettactic/api";
import { CreateRequestModal } from "@webV2/pages/settings/WorkplaceRequestsPage/components/CreateRequestModal";
import { ChatBotToolCard } from "@webV2/pages/Tessa/ChatBotToolCard";
import { useBooleanState } from "@gettactic/helpers";
import { CheckIcon } from "@v2/icons";
import { TacticLoader } from "@v2/components/loaders/TacticLoader/TacticLoader";

export const ChatBotToolShowWorkplaceRequestInfo: React.FC<
  TessaMessageRendererProps<AiChatToolBuildWorkplaceRequestPart>
> = ({ part }) => {
  const output = JSON.parse(part?.output || "null") as
    | AiChatToolBuildWorkplaceRequestOutput
    | undefined;

  const showSuccess = useBooleanState();

  if (!output) return <TacticLoader className={"opacity-60"} />;

  return (
    <ChatBotToolCard toolId={part.toolCallId}>
      {showSuccess.state ? (
        <div className={"flex items-center gap-2"}>
          <CheckIcon className={"size-10 text-green-500"} />
          Workplace request created successfully.
        </div>
      ) : (
        <CreateRequestModal
          isOpen={true}
          onOpenChange={() => null}
          isModal={false}
          defaultValues={{
            title: output?.title || "",
            description: output?.description || "",
            location: output?.office_id || "",
            type: output?.type_id || ""
          }}
          onCreated={() => showSuccess.true()}
        />
      )}
    </ChatBotToolCard>
  );
};
